import { ServiceError } from '../errors'
import { readLocal, writeLocal } from '../local-store'
import { simulate } from '../mock-utils'
import type { AcompanantesService, Invitation } from './types'

export const INVITATIONS_FIELD = 'invitations'
const FIELD = INVITATIONS_FIELD
const REVOKED_FIELD = 'revokedAccess'

/** Jorge, invitado por WhatsApp el 15 sep y sin empezar (CheckIn.dc.html paso 1). */
const DEMO: Invitation[] = [{ id: 'INV-1', name: 'Jorge', channel: 'whatsapp', contact: '+34 612 000 111', sentAt: '2026-09-15T10:12:00+02:00', started: false }]

/**
 * POSPUESTO: todo el servicio es simulado y se guarda en el dispositivo (D22). `withSample` añade la
 * invitación de ejemplo del bundle; la implementación real (D29) la usa sin ejemplo.
 */
export function createAcompanantes(withSample: boolean): AcompanantesService {
  const load = (guestCode: string): Invitation[] => {
    const local = readLocal<Invitation[]>(guestCode, FIELD)
    if (local) return local
    return !withSample || guestCode.includes('hotel') || guestCode.includes('titular-pendiente') ? [] : DEMO
  }
  return {
  async list(stay, signal) {
    await simulate(stay.guestCode, 'acompanantes', signal)
    return load(stay.guestCode)
  },
  async invite(stay, input) {
    await simulate(stay.guestCode, 'acompanantes')
    const invitation: Invitation = { id: `INV-${Date.now()}`, name: input.name?.trim() || null, channel: input.channel, contact: input.contact.trim(), sentAt: new Date().toISOString(), started: false }
    writeLocal(stay.guestCode, FIELD, [...load(stay.guestCode), invitation])
    return invitation
  },
  async resend(stay, invitationId) {
    await simulate(stay.guestCode, 'acompanantes')
    const list = load(stay.guestCode)
    const found = list.find((i) => i.id === invitationId)
    if (!found) throw new ServiceError('server', 'invitation not found')
    const updated = { ...found, sentAt: new Date().toISOString() }
    writeLocal(stay.guestCode, FIELD, list.map((i) => (i.id === invitationId ? updated : i)))
    return updated
  },
  async revoke(stay, id) {
    await simulate(stay.guestCode, 'acompanantes')
    const list = load(stay.guestCode)
    if (list.some((i) => i.id === id)) writeLocal(stay.guestCode, FIELD, list.filter((i) => i.id !== id))
    else writeLocal(stay.guestCode, REVOKED_FIELD, [...new Set([...(readLocal<string[]>(stay.guestCode, REVOKED_FIELD) ?? []), id])])
  },
  async listRevoked(stay, signal) {
    await simulate(stay.guestCode, 'acompanantes', signal)
    return readLocal<string[]>(stay.guestCode, REVOKED_FIELD) ?? []
  },
  }
}

export const acompanantesMock: AcompanantesService = createAcompanantes(true)
